import { Grid } from "@mui/material";
import React from "react";
import MenuTable from "../Menu/MenuTable";
import OrderTable from "../Orders/OrderTable";

const RestaurantDashboard = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={12} >
        <MenuTable />
      </Grid>
      <Grid item xs={12} lg={12}>
        <OrderTable />
      </Grid>
    </Grid>
  );
};

export default RestaurantDashboard;
